import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import * as Sentry from "@sentry/react";

import { App } from "app/app";
Sentry.init({
  dsn: "https://fdbdd29b5e44478b88d679d0543ac4bf@o4505432424775680.ingest.us.sentry.io/4505569057636352",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [],
});

const container = document.getElementById("app");
const root = createRoot(container!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
